import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { Globe, Plane, Target, Mic, Video, ChevronRight, BookOpen } from 'lucide-react';

export const EgitimlerHubContent = ({ setActiveSection }) => {
  const egitimSections = [
    { id: 'egitim-ingilizce', title: 'İngilizce Eğitimi', description: 'İngilizce müfredat ve ders içerikleri yönetimi', icon: <Globe className="w-6 h-6" />, stats: '9 Seviye', color: 'blue' },
    { id: 'egitim-kabin', title: 'Kabin Memurluğu', description: 'Kabin memurluğu eğitim modülleri yönetimi', icon: <Plane className="w-6 h-6" />, stats: '16 Modül', color: 'indigo' },
    { id: 'egitim-seviye', title: 'Seviye Testi', description: 'Seviye belirleme sınavı soruları yönetimi', icon: <Target className="w-6 h-6" />, stats: '30 Soru', color: 'orange' },
    { id: 'skill-tests', title: 'Beceri Testleri', description: 'Speaking, Writing, Listening testleri yönetimi', icon: <Mic className="w-6 h-6" />, stats: 'Testler', color: 'purple' },
    { id: 'video-courses', title: 'Videolu Dersler', description: 'Video içerikli ders yönetimi', icon: <Video className="w-6 h-6" />, stats: 'Videolar', color: 'red' }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    orange: 'bg-orange-100 text-orange-600',
    purple: 'bg-purple-100 text-purple-600',
    red: 'bg-red-100 text-red-600'
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-5 pb-3 border-b border-gray-200">
        <div className="p-2 bg-indigo-600 rounded-lg text-white">
          <BookOpen className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Eğitimler</h2>
          <p className="text-sm text-gray-500">Eğitim içerikleri ve müfredat yönetimi</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {egitimSections.map(section => (
          <Card 
            key={section.id}
            className="border border-gray-200 hover:border-indigo-300 hover:shadow-md transition-all cursor-pointer group bg-white"
            onClick={() => setActiveSection(section.id)}
          >
            <CardContent className="p-5">
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${colorClasses[section.color]}`}>
                  {section.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors">{section.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                  <span className="inline-block mt-2 text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">{section.stats}</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-indigo-500 group-hover:translate-x-1 transition-all flex-shrink-0" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default EgitimlerHubContent;
